import React, { useState } from "react";

const BotReplyRenderer = ({ botReply }) => {
  const MAX_LENGTH = 50;
  const [isExpanded, setIsExpanded] = useState(false);

  if (!botReply) return null; // Handle empty responses

  const shouldTruncate = botReply.length > MAX_LENGTH;
  const displayedText = isExpanded ? botReply : `${botReply.substring(0, MAX_LENGTH)}...`;

  return (
    <span>
      {displayedText}
      {shouldTruncate && (
        <button
          className="text-blue-500 ml-2 underline"
          onClick={(e) => {
            e.stopPropagation(); // Prevents unwanted table behavior
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}
    </span>
  );
};

export default BotReplyRenderer;
